import React, { Component } from "react";
import logo from "./nano.png";
import "./App.css";
import { PresentationCard } from "./PresentationCard.jsx";

class App extends Component {
  render() {
    return (
      <div className="App">
        <PresentationCard>
          This is a test. This is the portfolio of <b>Ignacio Brasca</b>.
        </PresentationCard>
        <hr />
        <PresentationCard>
          <img className="Image" src={logo} alt="Me." />
          <ul style={{ listStyle: "none" }}>
            <li>
              ⌨ Full-stack Software Developer (React.JS, Python, C# and C++).{" "}
            </li>
            <li>🤖 AI Software Developer. </li>
            <li>🎵 Music producer (TXXNANO or TOO NANO).</li>
            <li>
              🔍 Researcher (
              <a href="https://www.researchgate.net/profile/Ignacio_Brasca">
                Link to Research Gate.
              </a>
              )
            </li>
            <li>
              🎮 Game Design ({" "}
              <a href="https://www.indiedb.com/games/the-recovery">
                THE RECOVERY
              </a>{" "}
              <a href="https://www.indiedb.com/games/the-recovery">CAMINANTE</a>{" "}
              )
            </li>
          </ul>
        </PresentationCard>
        <hr />
        <PresentationCard>
          {" "}
          <div className="Footer">
            Contact me on{" "}
            <a href="https://www.linkedin.com/in/ignaciobrasca/">LinkedIn.</a>
          </div>{" "}
        </PresentationCard>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js